// Vite 会按当前 mode 加载 .env.development / .env.production。
// 保留 DEV/PROD 回退值，避免在 HBuilderX 等未加载 mode 配置时地址为空。
const BASE_API : string = import.meta.env.VITE_BASE_API ||
	(import.meta.env.DEV ? 'http://ixueapi.test' : 'https://ixue.xingrensubing.top');
export {
	BASE_API
}
